import { render, staticRenderFns } from "./CardServices.vue?vue&type=template&id=6f04331e&"
import script from "./CardServices.vue?vue&type=script&lang=js&"
export * from "./CardServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f04331e')) {
      api.createRecord('6f04331e', component.options)
    } else {
      api.reload('6f04331e', component.options)
    }
    module.hot.accept("./CardServices.vue?vue&type=template&id=6f04331e&", function () {
      api.rerender('6f04331e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/CardServices.vue"
export default component.exports